import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import { OnboardingStatusDTO } from '../types/dtos';
import { UserResponseDTO } from '../types/dtos';

export const CHAVES_ONBOARDING = {
  status: ['onboarding', 'status'] as const,
};

const OnboardingService = {
  // GET /api/v1/users/me/onboarding → { onboardingCompleted: boolean }
  getOnboardingStatus: (): Promise<AxiosResponse<OnboardingStatusDTO>> =>
    api.get('/users/me/onboarding'),

  // PUT /api/v1/users/me/onboarding → UserResponseDTO
  completeOnboarding: (): Promise<AxiosResponse<UserResponseDTO>> =>
    api.put('/users/me/onboarding').then(invalidando(CHAVES_ONBOARDING.status)),
};

export default OnboardingService;
